import { PrimitiveAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { Segment } from '@/types';
import { surveyAtom } from './surveyAtom';

export const segmentsAtom = focusAtom(surveyAtom, (optic) =>
  optic.optional().prop('segments')
) as PrimitiveAtom<Array<Segment>>;
